import Link from 'next/link';
import moment from 'moment';

function ArticleBox(props) {
	const {
		title,
		createdAt,
		updatedAt,
		publishDate,
		description,
		slug,
		body,
		tagList = []
	} = props;

	const date = moment(publishDate).format('LL');
	const partly = body
		? body
				.slice(0, body.indexOf('<pre'))
				.replace(/<[^>]+>/g, '')
				.slice(0, 500)
		: '';

	return (
		<div className="box article">
			<article className="content">
				<h3 className="is-size-3">
					<Link href={`/blog/${slug}`}>
						<a className="has-text-black-ter">{title}</a>
					</Link>
				</h3>
				<p>
					Posted on &nbsp;
					<time dateTime={createdAt} className="has-text-link">
						{date}
					</time>
				</p>
				<p> {description} </p>
				<p className="dont-break-out"> {partly} </p>
				{/* <p><ReactMarkdown>{ partly }</ReactMarkdown></p> */}
				<div className="tags">
					{tagList.map((e, i) => (
						<span key={i} className="tag">
							{e}
						</span>
					))}
				</div>
				<div className="box is-shadowless">
					<Link href={`/blog/${slug}`}>
						<a className="has-text-weight-semibold right">Read more</a>
					</Link>
				</div>
			</article>
		</div>
	);
}

export default ArticleBox;
